import { render, staticRenderFns } from "./UpdateBoxInfo.vue?vue&type=template&id=38643845&scoped=true"
import script from "./UpdateBoxInfo.vue?vue&type=script&lang=js"
export * from "./UpdateBoxInfo.vue?vue&type=script&lang=js"
import style0 from "./UpdateBoxInfo.vue?vue&type=style&index=0&id=38643845&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38643845",
  null
  
)

export default component.exports